import { utils } from '@hh/global.js'

const { isScrolledToBottom } = utils;

class StoreLocator extends HTMLElement {
  constructor() {
    super()

    this.apiKey = this.dataset.apiKey

    this.select = this.querySelector('.js-store-region-select')
    this.select.addEventListener('change', this.handleSelectChange)
    this.filterInputs = this.querySelectorAll('.js-store-filter-select')
    this.filterInputs.forEach(filterInput => {
      filterInput.addEventListener('change', this.handleFilterChange.bind(this))
      filterInput.addEventListener('click', this.handleFilterClick)
    })
    this.storeTriggerWrappers = this.querySelectorAll('.js-store-button-wrapper');

    document.body.addEventListener('wheel', this.handleScroll.bind(this));

    this.addEventListener('store-locator-animate', (e) => this.fadeIn(e, 'change'))
    this.fadeIn(null, 'init')

    this.setHeight()

    if (this.apiKey != '') {
      this.querySelectorAll('.js-weather').forEach(el => {
        this.getWeather(el)
      })
    }

    const url = window.location.pathname
    const location = url.split(window.pageHandle)[1].replace('/', '')
    const [region, store] = location.split('--')
    if (store && region) {
      setTimeout(() => {
        document.querySelector(`#${region}-tab`).click()
        document.querySelector(`hh-button[key='store--${store}']`)?.dispatchEvent(
          new CustomEvent('openDrawer', {
            bubbles: true,
            composed: true,
            detail: {
              key: `store--${store}`
            }
          })
        )
        // seem to need such a high delay to let the shim work on ios
      }, 2000)
    }
  }

  handleScroll(e) {
    const activePanel = document.querySelector('[data-store-locator] .js-tabpanel:not(.hidden)');
    const activeDrawer = document.querySelector('.store-drawer.drawer-is-active');
    const header = document.querySelector('hh-sticky-header');

    // If scrolling within the store info drawer, do not scroll the store list
    if (activeDrawer?.contains(e.target) && !isScrolledToBottom(activeDrawer)) {
      return;
    }

    // If already partially scrolled down the page, allow normal page scrolling
    if (window.scrollY > (header?._announcementHeight || 20)) {
      document.body.classList.remove('scroll-lock-show-bar');
      return;
    }

    document.body.classList[isScrolledToBottom(activePanel) ? 'remove' : 'add']('scroll-lock-show-bar');

    // Scroll the store list up or down
    if (activeDrawer?.contains(e.target) || !activePanel.contains(e.target)) {
      activePanel.scroll({ top: activePanel.scrollTop + e.deltaY });
    }
  }

  handleSelectChange(e) {
    this.dispatchEvent(
      new CustomEvent('store-locator-select-change', {
        bubbles: true,
        composed: true,
        detail: {
          event: e
        },
      })
    )
  }

  handleFilterClick(e) {
    // Prevent drawer close on click
    e.stopPropagation();
  }

  handleFilterChange(e) {
    const filterValue = e.target.value;

    this.storeTriggerWrappers.forEach(storeTrigger => {
      const filters = storeTrigger.getAttribute('data-filters')?.split(',');
      if (filterValue === 'all-stores' || filters?.includes(filterValue)) {
        storeTrigger.classList.add('store-button__wrapper--visible');
      } else {
        storeTrigger.classList.remove('store-button__wrapper--visible');
        // Close drawer if open
        const storeDrawerKey = storeTrigger.querySelector('.js-drawer-trigger')?.getAttribute('key');
        const drawer = storeTrigger.querySelector(`hh-drawer[data-drawer='${storeDrawerKey}']`)
        if (drawer && drawer.classList.contains('drawer-is-active')) {
          drawer.close();
        }
      }
    })
  }

  setHeight() {
    const titleHeight = document.querySelector('.js-page-title').offsetHeight || 0;
    document.querySelector(':root').style.setProperty(`--hh-content-height`, `${titleHeight}px`);
  }

  fadeIn(e, src) {
    const target = src === 'init' ? document.querySelector('.js-tab.active').getAttribute('aria-controls') : e.detail.event.getAttribute('aria-controls')
    this.animateItems = document.querySelectorAll(`#${target} .js-animate`)

    this.animateItems.forEach((el, ind) => {
      setTimeout(() => {
        el.classList.add('js-animate-active')
      }, ind * 300)
    })
  }

  getWeather(el) {
    const city = el.dataset.city
    fetch(`https://api.weatherapi.com/v1/forecast.json?key=${this.apiKey}&q=${city}&days=1&aqi=no&alerts=no`)
      .then(res => res.json())
      .then(res => {
        if (res) {
          let icon = document.createElement('img');
          icon.src = res.current.condition.icon
          icon.alt = ''
          icon.role = 'presentation'
          el.appendChild(icon);
          let weather = document.createElement('span')
          weather.innerText = res.location.country == 'United States of America' ? `${res.current.temp_f}F` : `${res.current.temp_c}C`
          el.appendChild(weather)
        }
      })
  }
}

customElements.define('store-locator', StoreLocator)
